import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { UserPkg } from '../types/UserPkg'
import { uploadUserPkgReceipt } from '../userPkgService'

export const useUploadUserPkgReceipt = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: uploadUserPkgReceipt,
    onMutate: ({ packageId, price }) => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      const oldPkgs = queryClient.getQueryData([QUERY_KEYS.USER_PACKAGES])
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(item => (item.id === packageId ? { ...item, price: price ?? item.price } : item))
      )
      return { oldPkgs }
    },
    onSuccess: (res, { packageId }) => {
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.PACKAGE_TAXES, packageId] })
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(item =>
          item.id === packageId
            ? {
                ...item,
                buyingReciptKey: res.buyingReciptKey,
                price: res.price,
                falseReceiptDate: res.falseReceiptDate,
                valueInUSD: res.valueInUSD,
              }
            : item
        )
      )
    },
    onError: (_error, _, context) => {
      if (context?.oldPkgs) {
        queryClient.setQueryData([QUERY_KEYS.USER_PACKAGES], context.oldPkgs)
      }
    },
  })
}
